import { AxiosError } from "axios";
export var getErrorMessage = function (err, fallback) {
    var _a, _b, _c, _d, _e;
    if (fallback === void 0) { fallback = "Unexpected error"; }
    console.error(err);
    if (err instanceof AxiosError) {
        return (((_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) ||
            ((_c = err.response) === null || _c === void 0 ? void 0 : _c.statusText) ||
            err.message ||
            fallback);
    }
    if (typeof err === "string")
        return err;
    if (err && typeof err === "object") {
        var anyErr = err;
        return ((_e = (_d = anyErr.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.message) || anyErr.message || fallback;
    }
    return fallback;
};
